import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import apiServices from "../../services/apiServices";

// First, create the thunk
export const fetchAllBrokers = createAsyncThunk(
  "broker_state/fetchAllBrokers",
  async () => {
    const response = await apiServices.get("brokers");
    console.log(response.data.data);
    return response.data.data;
  }
);
export const addBroker = createAsyncThunk(
  "broker_state/addBroker",
  async (data) => {
    const response = await apiServices.post("broker", data);
    console.log(response.data.data);
    return response.data.data;
  }
);

const initialState = {
  brokers: [],
  error: "",
  loading:false
};

let brokerSlice = createSlice({
  name: "broker_state",
  initialState,
  reducers: {
    // insert actions here

     
    reset: function (state, action) {
      state.loading = false;
      state.errorMessage=""
      state.successMessage=""
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(fetchAllBrokers.pending, (state, action) => {
      state.loading = true;
      state.errorMessage=""
      state.successMessage=""
    });
    builder.addCase(fetchAllBrokers.fulfilled, (state, action) => {
      // Add user to the state array
      let brokers= [];
      action.payload &&
        action.payload.map((x) => {
          let broker = {
            id: x._id,
            brokerId:x.brokerId,
            firstName: x.firstName,
            lastName: x.lastName,
            homeAddress: x.homeAddress,
            businessAddress: x.businessAddress,
            country: x.country,
            city: x.city,
            mobile: x.mobile,
            email: x.email,
            status: x.status,
          };

          return brokers.push(broker);
        });
      state.brokers = brokers.sort();
      state.loading = false;
      
    });
    builder.addCase(fetchAllBrokers.rejected, (state, action) => {
      state.loading = true;
      state.successMessage=""
      console.log("error ", action.payload)
      state.errorMessage = "Oops !, server error in fetching brokers";
    });

    // add all broker
    builder.addCase(addBroker.pending, (state, action) => {
      state.loading = true;
      state.errorMessage=""
    });
    builder.addCase(addBroker.fulfilled, (state, action) => {
      // Add user to the state array
      let broker = {
        id: action.payload._id,
        firstName: action.payload.firstName,
        lastName: action.payload.lastName,
        homeAddress: action.payload.homeAddress,
        businessAddress: action.payload.businessAddress,
        country: action.payload.country,
        city: action.payload.city,
        mobile: action.payload.mobile,
        email: action.payload.email,
        status: action.payload.status,
      };
      state.brokers = [...state.brokers, broker];
      state.loading = false;
      state.successMessage="Successfully saved broker"
    });
    builder.addCase(addBroker.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = "Oops !, server error in adding broker";
      console.log(state.errorMessage);
    });
  },
});
export const {reset} = brokerSlice.actions;
export default brokerSlice.reducer;
